import React from 'react';
import { brand } from '../mock/data';

const Story = () => (
  <section id="story" className="relative bg-[var(--paper)] border-y border-[var(--line)] py-24 md:py-36">
    <div className="relative max-frame container-px text-center">
      <p className="reveal text-[11px] uppercase tracking-kicker text-[var(--muted)]">The 16th Anniversary</p>
      <img
        src={brand.marks.fl}
        alt="Lotus 16th Anniversary"
        className="reveal mx-auto mt-10 w-[clamp(200px,30vw,400px)] h-auto"
      />
      <h2 className="reveal mx-auto mt-12 font-display uppercase font-tight text-[clamp(2.2rem,5vw,4rem)] leading-[0.95]">
        16 Years of <span className="text-[var(--accent)]">Purple Lotus</span>
      </h2>
      <p className="reveal mx-auto mt-7 max-w-[760px] text-[clamp(1.25rem,2.4vw,1.9rem)] leading-[1.4] text-[var(--ink-soft)]">
        What started with just two pounds and a dream has grown into one of the{' '}
        <span className="text-[var(--accent)]">Bay Area’s</span> most trusted cannabis destinations.
      </p>
      <div className="reveal mt-10 inline-flex items-center gap-2.5 pill px-5 py-2.5">
        <span className="h-1.5 w-1.5 rounded-full bg-[var(--accent)]" />
        <span className="text-[12px] uppercase tracking-[0.18em] text-[var(--ink-soft)]">Only 20 pcs each color</span>
      </div>
    </div>
  </section>
);

export default Story;
